import React, {useEffect, useState} from 'react';
import Modal from "react-modal";
import {Link} from "react-scroll";
import Contacts from "../Contacts";

Modal.setAppElement('#root');
const ContactButton = () => {
    const [modalIsOpen, setModalIsOpen] = useState(false);

    useEffect(() => {
        if (modalIsOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
    });

    const handleOpenModal = () => {
        setModalIsOpen(true)
    }

    return (
        <li className="nav-item">
            <Link className="btn nav-link" activeClass="active" to="home">
                <data onClick={handleOpenModal}>
                    Contact Us
                </data>
            </Link>

            <Modal
                isOpen={modalIsOpen}
                onRequestClose={() => setModalIsOpen(false)}
                contentLabel="Contact Us"
            >
                <Contacts/>
                <button className="btn btn-danger" onClick={() => setModalIsOpen(false)}>Close</button>

            </Modal>
        </li>
    );
}

export default ContactButton;
